module.exports = __webpack_public_path__ + "videos/brushes_en.003e75c.mp4";